import {
  fetchPageAssets,
  pageAssetExists,
  pageLocaleVariantAvailability,
} from '../../ducks/hostedAssets.duck';
import {
  detectBrowserLocale,
  getLocaleFromCurrentUser,
  getLocaleFromLocalStorage,
  getLocaleFromSearchParams,
  getLocaleFromPathname,
  normalizeLocale,
} from '../../util/genericHelpers';

export const loadData = (params, search, config) => async (dispatch, getState) => {
  const originalPageId = params.pageId;
  const { currentUser } = getState().user || {};

  const localeFromSearch = getLocaleFromSearchParams(search);
  const localeFromPath =
    params.locale ||
    (typeof window !== 'undefined' ? getLocaleFromPathname(window.location?.pathname) : null);
  const localeFromStorage = getLocaleFromLocalStorage();
  const localeFromUser = getLocaleFromCurrentUser(currentUser);
  const localeFromConfig = config?.localization?.locale;

  const locale = normalizeLocale(
    localeFromSearch ||
      localeFromPath ||
      localeFromStorage ||
      localeFromUser ||
      localeFromConfig ||
      detectBrowserLocale() ||
      'en'
  );

  const isThaiLocale = locale === 'th';

  const thaiPath = `content/pages/${originalPageId}-thai.json`;
  const fallbackAsset = { [originalPageId]: `content/pages/${originalPageId}.json` };

  // Try Thai file, but keep the SAME redux key (originalPageId)
  if (isThaiLocale) {
    const thaiAsset = { [originalPageId]: thaiPath };
    const localizedAssets = await dispatch(fetchPageAssets(thaiAsset, false));
    const hasThaiVariant = Boolean(localizedAssets?.[originalPageId]);
    dispatch(pageLocaleVariantAvailability(originalPageId, hasThaiVariant));
    if (hasThaiVariant) {
      return localizedAssets;
    }

    return dispatch(fetchPageAssets(fallbackAsset, false));
  }

  const [englishAssets, hasThaiVariant] = await Promise.all([
    dispatch(fetchPageAssets(fallbackAsset, false)),
    dispatch(pageAssetExists(thaiPath)),
  ]);
  dispatch(pageLocaleVariantAvailability(originalPageId, hasThaiVariant));
  return englishAssets;
};
